(() => {
  'use strict';

  class RelatedProducts extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('[data-related-track]');
      const controls = this.querySelector('[data-related-controls]');
      const prev = this.querySelector('[data-related-prev]');
      const next = this.querySelector('[data-related-next]');
      if (!track || !controls || !prev || !next) return;

      const events = new AbortController();
      const update = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        controls.hidden = maximum <= 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      };
      const move = direction => {
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        track.scrollBy({
          left: direction * distance,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };

      prev.addEventListener('click', () => move(-1), { signal: events.signal });
      next.addEventListener('click', () => move(1), { signal: events.signal });
      track.addEventListener('scroll', update, { passive: true, signal: events.signal });
      const observer = new ResizeObserver(update);
      observer.observe(track);
      this.cleanup = () => {
        events.abort();
        observer.disconnect();
        controls.hidden = true;
      };
      update();
    }

    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  }

  if (!customElements.get('sniezkowo-related-products')) {
    customElements.define('sniezkowo-related-products', RelatedProducts);
  }
})();
